import { BaseModel } from './base.model';

export class Response extends BaseModel {
    public error: boolean;
    public error_code: number;
    public message: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload shape varies per endpoint and is read untyped across the app
    public data: any;
    public eTag: string;

    constructor(data) {
        super(data);
    }
}
